import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import { delegate } from '../action_x.js'
import { getName } from '../gallery.js'
import confirm from '#utilities/js/ea/confirm.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const onClick = object(listener, {
  type: click,
  passive,
  task: async (
    button
  ) => {
    const { ownerDocument, name, dataset } = button
    const video = one(`[id=${name.replace('delegate_', '')}]`, ownerDocument)
    const videoName = getName(video)
    const { confirm: confirmText } = dataset
    const result = await confirm(confirmText, '', [button])

    if (result && videoName) {
      delegate(videoName)
    }
  }
})

export default button => {
  onClick.listen(button)
}